import api from './api';

export const opheService = {
  // Categories & Service Catalog
  getCategories: (params = {}) => api.get('/ophe/categories', { params }),
  createCategory: (data) => api.post('/ophe/categories', data),
  updateCategory: (id, data) => api.patch(`/ophe/categories/${id}`, data),
  deleteCategory: (id) => api.delete(`/ophe/categories/${id}`),

  getServices: (params = {}) => api.get('/ophe/services', { params }),
  getServiceById: (id) => api.get(`/ophe/services/${id}`),
  createService: (data) => api.post('/ophe/services', data),
  updateService: (id, data) => api.patch(`/ophe/services/${id}`, data),
  deleteService: (id) => api.delete(`/ophe/services/${id}`),

  // Pipeline Leads & Stats
  getPipelineSummary: () => api.get('/ophe/pipeline/summary'),
  getPipelineLeads: (params = {}) => api.get('/ophe/pipeline/leads', { params }),
  getLeadById: (id) => api.get(`/ophe/pipeline/leads/${id}`),
  createLead: (data) => api.post('/ophe/pipeline/leads', data),
  updateLead: (id, data) => api.patch(`/ophe/pipeline/leads/${id}`, data),
  updateLeadStage: (id, data) => api.post(`/ophe/pipeline/leads/${id}/stage`, data),

  // Payment Link & Verification Sync
  createPaymentLink: (id, data) => api.post(`/ophe/pipeline/leads/${id}/payment`, data),
  sendPaymentLink: (id, data) => api.post(`/ophe/pipeline/leads/${id}/payment/send`, data),
  syncPayment: (id, data = {}) => api.post(`/ophe/pipeline/leads/${id}/sync-payment`, data),
  deletePaymentRecord: (id, paymentId) => api.delete(`/ophe/pipeline/leads/${id}/payment/${paymentId}`),

  // Provider Assignment
  assignProvider: (id, data) => api.post(`/ophe/pipeline/leads/${id}/assign-provider`, data),

  // Billing Calculation Engine
  calculateBilling: (data) => api.post('/ophe/pipeline/calculate-billing', data),

  // Payout Processing & Case Closure
  processPayout: (id, data) => api.post(`/ophe/pipeline/leads/${id}/payout`, data),
  completeCase: (id, data) => api.post(`/ophe/pipeline/leads/${id}/payout`, data),

  // External Website Sync
  syncExternalLeads: () => api.post('/ophe/pipeline/sync-external')
};

export default opheService;
